import { motion } from "framer-motion";

const FinalCTA = () => (
  <section
    id="get-trifit"
    data-testid="final-cta-section"
    className="relative flex min-h-screen items-center overflow-hidden"
  >
    <div className="absolute inset-0">
      <img
        src="/assets/closing_in.jpg"
        alt="A person facing their digital twin"
        className="h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-ink/55" />
    </div>

    <div className="relative z-10 mx-auto w-full max-w-[1600px] px-6 md:px-12">
      <p className="font-mono text-[11px] tracking-[0.28em] text-white/70">
        04 · BEGIN
      </p>
      <h2
        data-testid="final-cta-headline"
        className="mt-8 max-w-3xl font-display text-4xl font-light leading-tight text-white sm:text-5xl lg:text-6xl"
      >
        <motion.span
          className="block text-white"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-120px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        >
          Build the intelligence
        </motion.span>
        <motion.span
          className="block text-white"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-120px" }}
          transition={{ duration: 0.9, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
        >
          that knows <span className="text-signal">you</span>.
        </motion.span>
      </h2>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.9, delay: 0.5 }}
        className="mt-12 flex items-center gap-8"
      >
        <a
          href="https://xsdfem-1j.myshopify.com/"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="final-cta-button"
          className="bg-white px-9 py-4 font-mono text-[11px] tracking-[0.16em] text-ink transition-colors duration-300 hover:bg-signal hover:text-white"
        >
          GET TRIFIT
        </a>
        <a
          href="/science"
          data-testid="final-cta-secondary"
          className="font-mono text-[10px] tracking-[0.2em] text-white/60 transition-colors duration-300 hover:text-white"
        >
          EXPLORE THE SCIENCE →
        </a>
      </motion.div>
    </div>
  </section>
);

export default FinalCTA;
